import { render, staticRenderFns } from "./ColumnMappingsReadOnlyPanel.vue?vue&type=template&id=be1712de"
import script from "./ColumnMappingsReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./ColumnMappingsReadOnlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports